export const isEscPressed = event =>
  event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;

export const isEnterPressed = event => event.key === 'Enter' || event.keyCode === 13;
